<div class="admin-budget-title__header">
    <div class="d-flex justify-content-between admin-budget-title__container align-items-center">
        <span class="admin-budget-title__label">{{title}}</span>
        <ng-container *ngTemplateOutlet="btnTemplate">
        </ng-container>
    </div>
</div>